import { createStore } from 'vuex'
import access from './access'
import styles from './styles'

export default createStore({

  strict         : process.env.NODE_ENV !== "production",

  modules        : {
    access,
    styles,
  },

  state          : {

    isMobile          : false,
    location          : '',

    helper            : { top: window.innerHeight, left: 0, hidden: false },

    quadrants         : {},
    snippets          : [],
    anchors           : [],

    count             : 0,

  },

  mutations      : {

    setMobile     : (state, isMobile)     => state.isMobile     = isMobile,
    setLocation   : (state, slug)         => state.location     = slug,

    setHelper     : (state, position)     => state.helper       = { ...state.helper, ...position },

    setQuadrants  : (state, quadrants)    => state.quadrants    = quadrants,
    setSnippets   : (state, snippets)     => state.snippets     = snippets,
    setAnchors    : (state, anchors)      => state.anchors      = anchors,

    setCount      : (state, count)        => state.count        = count,


  },

  actions          : {
  },

  getters          : {

    quadrantsArray : state => Object.values(state.quadrants),
    quadrantBySlug : (state, getters) => slug => (
      getters.quadrantsArray.find(q => q.slug == slug)
    ),
    currentQuadrant : (state, getters) => (
      getters.quadrantBySlug(state.location)
    )


  },
})
